module.exports = __webpack_public_path__ + "static/media/volcanoBGDesktop.b387d3ad.webp";